const GOOGLE_REVIEWS_URL = 'https://share.google/F76JwBmw2BjczjGxr';

const reviews = [
  {
    name: 'Monu Tiwari',
    text: 'he is running shoping ads for my business and now i wmm getting ore sales best digital marketing agency',
  },
  {
    name: 'Priyanka',
    text: 'best google ads providers in bijnor',
  },
  {
    name: 'Neeraj Singh Rathor',
    text: '',
  },
];

const GoogleReviewsSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Rated 5.0 on Google
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real reviews from real clients on our Google Business Profile.
          </p>
          <p className="text-sm text-muted-foreground">
            <span className="text-amber-400">★★★★★</span> 5.0 · 3 Google reviews
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div key={review.name} className="bg-card border border-border rounded-xl p-6 space-y-4">
              <div className="text-amber-400 text-lg">★★★★★</div>
              {review.text ? (
                <p className="text-sm text-muted-foreground leading-relaxed">“{review.text}”</p>
              ) : (
                <p className="text-sm text-muted-foreground leading-relaxed">Rated us 5 stars on Google.</p>
              )}
              <p className="text-sm font-semibold text-foreground">{review.name}</p>
              <p className="text-xs text-muted-foreground">via Google</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary text-white text-sm font-semibold hover:opacity-90 transition-opacity"
          >
            See all reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewsSection;
